import 'slick-carousel';
const $productImagesSlider = $('.js-product-images');

$(window).on('load resize', function() {
	if ($(window).width() <= 767 && !$productImagesSlider.hasClass('slick-initialized')) {
		$productImagesSlider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
		});

		if ($('.current-image-variant').length && $(window).width() <= 767 && !$('[data-single-color]').length) {
			let slideNumber = $('.current-image-variant')
				.parents('.slick-slide')
				.data('slick-index');
			$productImagesSlider.slick('slickGoTo', slideNumber);
		}
	} else if ($(window).width() > 767 && $productImagesSlider.hasClass('slick-initialized')) {
		$productImagesSlider.slick('unslick');
	}
});
